import { render, staticRenderFns } from "./RegionFarmerGroupsDetail.vue?vue&type=template&id=3f365b22&scoped=true&"
import script from "./RegionFarmerGroupsDetail.vue?vue&type=script&lang=js&"
export * from "./RegionFarmerGroupsDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegionFarmerGroupsDetail.vue?vue&type=style&index=0&id=3f365b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f365b22",
  null
  
)

export default component.exports